<template>
	<div>
		<div class="content">
			<h1 class="title is-bold">Log in</h1>
			<!-- <p class="subtitle">Let&#39;s get started.</p> -->
		</div>
		<form-login
			:fetching="fetching"
			:message="message"
			:message-type="messageType"
			@submit="submit"
		></form-login>
		<div class="content copyright is-centered">
			<p>
				<router-link :to="forgottenpassword">Forgot password?</router-link>
			</p>
			<p>
				&copy; DailyCare Pty Ltd &middot;
				<a
					href="https://www.dailycare.com.au/terms-of-use/"
					target="_blank"
					rel="noreferrer"
					>Terms of use</a
				>
				&middot;
				<a
					href="https://www.dailycare.com.au/privacy-policy/"
					target="_blank"
					rel="noreferrer"
					>Privacy policy</a
				>
			</p>
			<p v-show="false">
				Looking for ways to grow your business
				<a href="#">learn more</a>
			</p>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: "AuthLogin",
	computed: {
		...mapGetters({
			user: "userModule/get",
			fetching: "authentication/fetching",
			message: "authentication/message",
			messageType: "authentication/messageType"
		}),
		forgottenpassword() {
			return { name: "ForgottenPassword" };
		}
	},
	methods: {
		...mapActions({
			login: "authentication/login"
		}),
		async submit(data) {
			await this.login(data);
			if (this.user) {
				let path = "/";
				if (this.$route.query && this.$route.query.redirect) {
					path = this.$route.query.redirect;
				}
				this.$router.push(path);
			}
		}
	}
};
</script>
